import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Route } from "react-router-dom";
import { ConnectedRouter } from "react-router-redux";

import { getHistory } from "Router/getHistory";
import { createStore } from "Store/createStore";
import App from "App";

import { preConfigureHttpRequests } from "Utils";

// Load jquery
import "script-loader!jquery/dist/jquery.min.js"; // eslint-disable-line

// Load foundation
import "foundation-sites/dist/js/plugins/foundation.core";
import "foundation-sites/dist/js/plugins/foundation.util.keyboard.js";
import "foundation-sites/dist/js/plugins/foundation.util.triggers.js";
import "foundation-sites/dist/js/plugins/foundation.util.mediaQuery.js";
import "foundation-sites/dist/js/plugins/foundation.util.motion.js";
import "foundation-sites/dist/js/plugins/foundation.util.box.js";
import "foundation-sites/dist/js/plugins/foundation.reveal.js";
import "foundation-sites/dist/js/plugins/foundation.offcanvas.js";
import "foundation-sites/dist/js/plugins/foundation.tooltip.js";

// Ant Design
import "antd/dist/antd.css";

// Load App styles
import "ApplicationStyles";

import "react-notifications/lib/notifications.css";

// Create Redux store
const store = createStore();

// Get browser history
const history = getHistory();

// Configure an interceptor to add TT auth params to each TTP_API's request
preConfigureHttpRequests();

// Render App
ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Route component={App} />
    </ConnectedRouter>
  </Provider>,
  document.getElementById("app")
);



// WEBPACK FOOTER //
// ./src/index.js